import { trackGetApp } from "@/events/landingPagesMixpanel";
import { cn } from "@/lib/utils";
import { androidAppUrl } from "@/settings";
import { useTranslation } from "@repo/shared/i18n";

import { GooglePlayIcon } from "./PlatformIcons";

// The store's name, never translated.
const STORE_NAME = "Google Play";

/** The store badge ("Get it on Google Play"), linking to the beta's listing. */
export const GooglePlayBadge = ({ className }: { className?: string }) => {
  const { t } = useTranslation("appLanding");
  return (
    <a
      href={androidAppUrl("front_page_banner")}
      target="_blank"
      rel="noreferrer"
      onClick={() => trackGetApp("front_page_banner")}
      aria-label={t("androidBeta.cta")}
      className={cn(
        "inline-flex h-14 shrink-0 items-center gap-3 rounded-xl border border-neutral-600 bg-black pl-3.5 pr-5 text-white",
        "transition-colors hover:border-neutral-400",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-blue",
        className,
      )}
    >
      <GooglePlayIcon className="size-6" />
      {/* pt-0.5 nudges the text 1px down: "Google Play" has descenders, so
          centring the boxes leaves the caps sitting high. */}
      <span
        aria-hidden
        className="flex flex-col gap-1 whitespace-nowrap pt-0.5 font-sans leading-none"
      >
        <span className="text-[10px] font-semibold uppercase tracking-[.06em]">
          {t("androidBeta.badgeLabel")}
        </span>
        <span translate="no" className="text-xl font-medium tracking-tight">
          {STORE_NAME}
        </span>
      </span>
    </a>
  );
};
